export default  {
  bindings: {
    property: '<',
    formTab: '='
  },
  controller: 'propertyBrandFormController',
  template: require('../views/property.brand.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.brand.form.component.js